<template>
  <b-modal
    title="Choix d'élément"
    :modal-class="'base-modal middle-size'"
    centered
    ref="elementModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <b-container fluid>
      <b-row class="mb-4 text-center">
        <b-col class="item">
          <b-button @click="elementTypeClick('text')" class="btn-item">
            <icon-base iconName="text" /> Bloc de texte
          </b-button>
        </b-col>
        <b-col class="item">
          <b-button @click="elementTypeClick('drop')" class="btn-item">
            <font-awesome-icon :icon="['fas', 'table']" /> Bloc de données
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-4 text-center">
        <b-col class="item">
          <b-button @click="elementTypeClick('logo')" class="btn-item">
            <font-awesome-icon :icon="['fas', 'image']" /> Logo
          </b-button>
        </b-col>
        <b-col class="item">
          <b-button @click="elementTypeClick('image')" class="btn-item">
            <font-awesome-icon :icon="['fas', 'file-image']" /> Image
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <b-button variant="primary" size="lg" class="float-right" @click="close">
        Annuler
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import iconBase from '../../icons/iconBase'
export default {
  components: {
    iconBase
  },
  methods: {
    close () {
      this.$refs['elementModal'].hide()
    },
    open () {
      this.$refs['elementModal'].show()
    },
    elementTypeClick (type) {
      this.$emit('addElement', type)
      this.$refs['elementModal'].hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  .btn-item {
    padding: 5px;
    border-radius: 0;
    border: 1px solid #2b3085;
    background-color: #fff;
    height: 100px;
    width: 100%;
    color: #2b3085;
    &:hover {
      color: whitesmoke;
      border-color: #2b3085;
      background-color: #2b3085;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/selectionElement.vue